/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import trackEvent from '../../helpers/analytics-utils/track-event'
import style from './index.module.scss'

const ExternalLink: React.FC<ExternalLinkProps> = ({
  url,
  className,
  eventCategory,
  eventAction,
  eventLabel,
  children,
  target,
  rel,
  ...otherProps
}): JSX.Element => {
  const props = {
    href: url,
    target,
    rel,
    className: classNames(className, { [style.ExternalLink]: !className }),
    ...otherProps,
  }
  return (
    <a
      onClick={
        eventCategory
          ? () => trackEvent(eventCategory, eventAction, eventLabel)
          : undefined
      }
      {...props}
    >
      {children}
    </a>
  )
}

interface ExternalLinkProps {
  url: string
  className?: string
  eventCategory?: string
  eventAction?: string
  eventLabel?: string
  children?: React.ReactNode
  target?: string
  rel?: string
  otherProps?: unknown
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

ExternalLink.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  eventCategory: PropTypes.string,
  eventAction: PropTypes.string,
  eventLabel: PropTypes.string,
  children: PropTypes.node,
  target: PropTypes.string,
  rel: PropTypes.string,
}

ExternalLink.defaultProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

export default ExternalLink
